import React from "react";

const SpendingDetails = ({ entries = [], active = false, onClose, title }) => {
	return (
		<div className={`spending-details ${active ? "active" : ""}`}>
			<div className="close" onClick={onClose}>
				&times;
			</div>
			<div className="inner">
				<p className="title3">{title || "Details"}</p>
				<div className="table horizontal">
					<div className="row hd">
						<div className="col">Date</div>
						<div className="col">Description</div>
						<div className="col">Amount</div>
					</div>
					{entries.map((it, idx) => {
						const amount = typeof it.transaction === "number" ? it.transaction : Number(it.transaction || 0);
						const desc = it.description || it.note || it.merchant || it.category || "";
						const dateStr = it.date ? new Date(it.date).toLocaleDateString("en-US") : "";
						return (
							<div className="row" key={idx}>
								<div className="col">{dateStr}</div>
								<div className="col">{desc}</div>
								<div className={amount < 0 ? "col red" : "col"}>{Math.round(amount).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0 })}</div>
							</div>
						);
					})}
					{(() => {
						const total = entries.reduce((sum, it) => {
							const amt = typeof it.transaction === "number" ? it.transaction : Number(it.transaction || 0);
							return sum + amt;
						}, 0);
						return (
							<div className="row total">
								<div className="col"></div>
								<div className="col">Total</div>
								<div className="col">{Math.round(total).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0 })}</div>
							</div>
						);
					})()}
				</div>
			</div>
		</div>
	);
};

export default SpendingDetails;
